const styles = `:host {
  height: 36px;
  width: 36px;
  --goto-icon-size: 1.5rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  user-select: none;
  outline: 0;
  font: var(--goto-avatar-36);
  font-weight: bold;
  position: relative;
  text-align: center;
  /* Using !important here is necessary. The most common reason is for MUI to add
    * { box-sizing: content-box; }
    and that will override any
    :host { box-sizing: border-box }
    in our code
  */
  box-sizing: border-box !important;
  position: relative;
  background: var(--goto-avatar-bg-color);
  border: solid 1px transparent;
}
:host ::slotted(img) {
  border-radius: 50%;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
:host ::slotted(chameleon-icon-badge) {
  border: 2px solid var(--goto-text-04);
  position: absolute;
  bottom: 0;
  right: 0;
}
:host ::slotted(svg) {
  color: var(--goto-icon-color);
  height: var(--goto-spacing-06);
  width: var(--goto-spacing-06);
}
:host ::slotted([slot=presence]) {
  background-color: var(--goto-text-04);
  border-radius: 50%;
  bottom: var(--goto-avatar-presence-bottom, -2px);
  display: inline-flex;
  line-height: 1;
  padding: 1px;
  position: absolute;
  right: var(--goto-avatar-presence-right, -2px);
}
:host ::slotted(.button-overlay) {
  position: absolute;
  pointer-events: none;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: var(--goto-blue-300);
  border-radius: 50%;
  opacity: 0;
  width: 100%;
  height: 100%;
}

:host([type=button]:not([disabled])) {
  cursor: pointer;
}

:host(:hover) ::slotted(.button-overlay) {
  opacity: 0.4;
}

:host(:active) ::slotted(.button-overlay) {
  opacity: 0.6;
}

:host(:focus-visible) {
  border-width: 1px;
  border-style: solid;
  border-color: var(--goto-focus);
  box-shadow: var(--goto-highlight);
}

:host([size=xsmall]) {
  height: 24px;
  width: 24px;
  font: var(--goto-avatar-24);
  --goto-icon-size: 1rem;
}
:host([size=xsmall]) ::slotted(svg) {
  height: var(--goto-spacing-04);
  width: var(--goto-spacing-04);
}

:host([size=small]) {
  height: 30px;
  width: 30px;
  font: var(--goto-avatar-30);
  --goto-icon-size: 20px;
}
:host([size=small]) ::slotted(svg) {
  height: var(--goto-spacing-05);
  width: var(--goto-spacing-05);
}

:host([size=large]) {
  height: 48px;
  width: 48px;
  font: var(--goto-avatar-48);
  --goto-icon-size: 2rem;
  --goto-avatar-presence-bottom: 0;
  --goto-avatar-presence-right: 0;
}
:host([size=large]) ::slotted(svg) {
  height: var(--goto-spacing-07);
  width: var(--goto-spacing-07);
}
:host([size=large]) ::slotted(chameleon-icon-badge) {
  right: -4px;
}

:host([size=xlarge]) {
  height: 64px;
  width: 64px;
  font: var(--goto-avatar-64);
  --goto-icon-size: 44px;
}
:host([size=xlarge]) ::slotted(svg) {
  height: 44px;
  width: 44px;
}
:host([size=xlarge]) ::slotted(chameleon-icon-badge) {
  bottom: 2px;
}

:host([size=xxlarge]) {
  height: 80px;
  width: 80px;
  font: var(--goto-avatar-80);
  --goto-icon-size: 52px;
}
:host([size=xxlarge]) ::slotted(svg) {
  height: 52px;
  width: 52px;
}
:host([size=xxlarge]) ::slotted(chameleon-icon-badge) {
  bottom: 4px;
}

:host([size=xlarge]),
:host([size=xxlarge]) {
  --goto-avatar-presence-bottom: 4px;
  --goto-avatar-presence-right: 4px;
}

:host([size=xxxlarge]) {
  height: 180px;
  width: 180px;
  font: var(--goto-avatar-180);
  --goto-icon-size: 116px;
}
:host([size=xxxlarge]) ::slotted(svg) {
  height: 116px;
  width: 116px;
}

:host([variant=primary]) {
  --goto-icon-color: var(--goto-text-06);
  color: var(--goto-text-04);
}

:host([variant=secondary]) {
  --goto-icon-color: var(--goto-avatar-secondary-icon-color);
  --goto-avatar-bg-color: var(--goto-avatar-secondary);
  color: var(--goto-text-02);
}

:host([variant=neutral]) {
  --goto-icon-color: var(--goto-text-06);
  --goto-avatar-bg-color: var(--goto-avatar-neutral);
  color: var(--goto-text-04);
}

:host([hint]) {
  --goto-avatar-bg-color: var(--goto-avatar-group-max-hint);
}

:host(.with-image) {
  background: none;
}

:host([disabled][type=button]) ::slotted(.button-overlay) {
  background-color: var(--goto-avatar-disabled-color);
  opacity: 1;
}

:host([disabled][type=button]:not(.with-image)) ::slotted(.button-overlay) {
  opacity: 0;
}

:host([disabled][type=button][variant=secondary]:not(.with-image)) {
  background: var(--goto-inverse-ui-05);
  color: var(--goto-disabled-04);
  border: 1px solid var(--goto-disabled-04);
}

:host([disabled][type=button][variant=primary]:not(.with-image)) {
  color: var(--goto-disabled-04);
  background: var(--goto-disabled-02);
}

:host([disabled][type=button][variant=neutral]:not(.with-image)) {
  color: var(--goto-disabled-04);
  background: var(--goto-disabled-02);
}`; export default styles;